import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Consts } from '@commons/consts/consts';
import { BusinessEvent } from '@commons/models/domain/BusinessEvent';

@Component({
  selector: 'app-area-item',
  templateUrl: './area-item.component.html',
  styleUrls: ['./area-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AreaItemComponent implements OnInit {

  @Output() public onClickArea$: EventEmitter<BusinessEvent> = new EventEmitter();

  @Input() public eventData: BusinessEvent;

  public readonly EVENT_TYPE = Consts;

  constructor() { }

  ngOnInit(): void {
  }

}
